module.exports = "data:image/png;base64,ZXhwb3J0IGRlZmF1bHQgX193ZWJwYWNrX3B1YmxpY19wYXRoX18gKyAiZDhkNWQ2ZmQ2MzhkNDRiODUwMzc1ZjdhYjlmNWI3Y2MucG5nIjs="